import React from 'react';
import './WhatsAppButton.css';

const WHATSAPP = process.env.REACT_APP_WHATSAPP || '919395419651';

function WhatsAppIcon() {
  return (
    <svg viewBox="0 0 32 32" width="28" height="28" fill="currentColor" aria-hidden="true">
      <path d="M16.004 0C7.164 0 .002 7.163.002 16c0 2.82.738 5.567 2.14 7.995L0 32l8.2-2.107A15.93 15.93 0 0 0 16.004 32C24.84 32 32 24.837 32 16S24.84 0 16.004 0Zm0 29.09a13.03 13.03 0 0 1-6.66-1.826l-.478-.284-4.868 1.252 1.3-4.75-.312-.488A13.03 13.03 0 0 1 2.914 16c0-7.223 5.876-13.09 13.09-13.09 7.222 0 13.09 5.867 13.09 13.09 0 7.223-5.868 13.09-13.09 13.09Zm7.17-9.803c-.393-.196-2.323-1.146-2.684-1.277-.36-.13-.622-.196-.883.196-.262.393-1.014 1.277-1.243 1.539-.229.262-.458.295-.85.098-.393-.196-1.658-.611-3.158-1.949-1.168-1.041-1.956-2.327-2.185-2.72-.229-.393-.024-.605.172-.8.177-.176.393-.458.59-.687.196-.229.262-.393.393-.655.13-.262.065-.49-.033-.687-.098-.196-.883-2.128-1.21-2.914-.318-.764-.642-.661-.883-.673l-.752-.013c-.262 0-.687.098-1.047.49-.36.393-1.374 1.343-1.374 3.276 0 1.932 1.407 3.8 1.603 4.062.196.262 2.767 4.226 6.706 5.924.937.404 1.667.646 2.237.827.94.299 1.795.257 2.472.156.754-.113 2.323-.95 2.65-1.867.328-.917.328-1.703.23-1.866-.098-.163-.36-.262-.753-.458Z" />
    </svg>
  );
}

export default function WhatsAppButton() {
  return (
    <a
      className="whatsapp-fab"
      href={`https://wa.me/${WHATSAPP}?text=${encodeURIComponent('Hi Skyleaf Travels! I want to plan a trip.')}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <WhatsAppIcon />
    </a>
  );
}
